module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/instagram/sola_sns_01-b3278dfa361636e67aa6952d4c768ace.jpg";